import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";
import JsonEditor from "./JsonEditor";

/**
 * Campaign Metafields Edit Form Component
 */
const CampaignMetafieldsEditForm = ({
    store_domain,
    metafields,
    jsonError,
    onJsonChange,
    onSubmit,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "right" }}
                >
                    Store Domain
                </Label>
                <Col sm={4}>
                    <Input
                        value={store_domain}
                        type="text"
                        name="store"
                        className="form-control"
                        id="horizontal-store_domain-Input"
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-placement-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "right" }}
                >
                    Metafields
                </Label>
                <Col sm={9}>
                    <JsonEditor initialValue={metafields} onChange={onJsonChange} />
                    <p style={{ color: 'red' }}>{jsonError || ""}</p>
                </Col>
            </FormGroup>
            <FormGroup className="row justify-content-end">
                <Col sm={10}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Save
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

CampaignMetafieldsEditForm.propTypes = {
    store_domain: PropTypes.string.isRequired,
    metafields: PropTypes.object.isRequired,
    jsonError: PropTypes.string,
    onJsonChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CampaignMetafieldsEditForm;

